import React from 'react';
import { motion } from 'framer-motion';
import { FaUserGraduate } from "react-icons/fa6";
import { GiGraduateCap } from "react-icons/gi";

const education = [
  {
    degree: 'M.Sc.',
    school: 'University of Lagos',
    notes: "(WES: Canadian Master's Equivalency)",
    icon: <FaUserGraduate className="text-white-400" />, name: 'Masters Degree' 
    
  },
  {
    degree: 'B.Eng.',
    school: 'Madonna University, Nigeria (Electrical & Electronics)',
    notes: '',
    icon: <GiGraduateCap className="text-white-400" />, name: 'GraduateDegree' 
    
  }
];

const Education = () => {
  return (
    <section id="education" className="my-20 max-w-3xl mx-auto px-4">
      <motion.h2
        className="text-3xl font-bold mb-6 text-softPurple"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        Education
      </motion.h2>
      <div className="space-y-6">
        {education.map(({ degree, school, notes, icon }, index) => (
        <motion.div
          key={index}
          className="bg-gray-800 rounded-xl p-4 shadow-lg hover:shadow-glow transition-shadow"
          whileHover={{ scale: 1.03 }}
        >
          <div className="flex items-start gap-4">
            {/* Icon as profile-style avatar */}
            <div className="w-14 h-14 flex items-center justify-center">
              <span className="text-5xl text-white">{icon}</span>
            </div>

            {/* Text content */}
            <div>
              <h3 className="text-lg font-semibold text-white">{degree}</h3>
              <p className="text-gray-300">{school}</p>
              {notes && <p className="text-gray-400 italic mt-1">{notes}</p>}
            </div>
          </div>
        </motion.div>

        ))}
      </div>
    </section>
  );
};

export default Education;
